import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'
import VerticalDrawer from './verticalDrawer/index'

import {
  BurgerIcon,
  BurgerLine,
  MobileNavWrapper,
  MobileNavOverlay,
  MobileNavOffCanvas,
  MobileNavContent,
  Top,
  Bottom,
  MobileNavItem,
  SvgBg,
  Copyright,
} from './styled/styles'

function Burger({ className, active, onClick }) {
  const intl = useIntl()
  const activeClass = 'text-red'
  return (
    <div className={clsx(className, { active: active })} data-testid="burger">
      <BurgerIcon active={active}>
        <BurgerLine />
        <BurgerLine />
        <BurgerLine />
      </BurgerIcon>
      <MobileNavWrapper active={active}>
        <MobileNavOverlay active={active} />
        <MobileNavOffCanvas active={active}>
          <SvgBg>
            <img src="/img/tracklines/backgrounds/Randlinie3.svg" alt="" />
          </SvgBg>
          <MobileNavContent
            data-testid="navigation"
            onClick={(event) => event.stopPropagation()}
          >
            <Top>
              <MobileNavItem
                to={intl.formatMessage({ id: 'path.vision' })}
                onClick={onClick}
                activeClassName={activeClass}
              >
                <FormattedMessage id="navigation.vision" />
              </MobileNavItem>
              <MobileNavItem
                to={intl.formatMessage({ id: 'path.concept' })}
                onClick={onClick}
                activeClassName={activeClass}
              >
                <FormattedMessage id="navigation.concept" />
              </MobileNavItem>
              <MobileNavItem
                to={intl.formatMessage({ id: 'path.implementation' })}
                onClick={onClick}
                activeClassName={activeClass}
              >
                <FormattedMessage id="navigation.implementation" />
              </MobileNavItem>
              <VerticalDrawer
                headline={intl.formatMessage({
                  id: 'navigation.factsandinfos',
                })}
              >
                <MobileNavItem
                  to={intl.formatMessage({ id: 'path.factsandinfos.facts' })}
                  onClick={onClick}
                  activeClassName={activeClass}
                >
                  <FormattedMessage id="navigation.factsandinfos.facts" />
                </MobileNavItem>
                <MobileNavItem
                  to={intl.formatMessage({ id: 'path.factsandinfos.faq' })}
                  onClick={onClick}
                  activeClassName={activeClass}
                >
                  <FormattedMessage id="navigation.factsandinfos.faq" />
                </MobileNavItem>
                <MobileNavItem
                  to={intl.formatMessage({ id: 'path.factsandinfos.glossary' })}
                  onClick={onClick}
                  activeClassName={activeClass}
                >
                  <FormattedMessage id="navigation.factsandinfos.glossary" />
                </MobileNavItem>
              </VerticalDrawer>
              <VerticalDrawer
                headline={intl.formatMessage({
                  id: 'navigation.newsanddownloads',
                })}
                headlinePath="path.newsanddownloads"
              >
                <MobileNavItem
                  to={intl.formatMessage({
                    id: 'path.newsanddownloads.downloads',
                  })}
                  onClick={onClick}
                  activeClassName={activeClass}
                >
                  <FormattedMessage
                    id={'navigation.newsanddownloads.downloads'}
                  />
                </MobileNavItem>
                <MobileNavItem
                  to={intl.formatMessage({
                    id: 'path.newsroom',
                  })}
                  onClick={onClick}
                  activeClassName={activeClass}
                >
                  <FormattedMessage id={'navigation.newsanddownloads.press'} />
                </MobileNavItem>
                <MobileNavItem
                  to={intl.formatMessage({
                    id: 'path.blog',
                  })}
                  onClick={onClick}
                  activeClassName={activeClass}
                >
                  <FormattedMessage id={'navigation.newsanddownloads.blog'} />
                </MobileNavItem>
              </VerticalDrawer>
            </Top>
            <Bottom>
              <Copyright
                html={intl.formatMessage({ id: 'footer.copyright' })}
              />
            </Bottom>
          </MobileNavContent>
        </MobileNavOffCanvas>
      </MobileNavWrapper>
    </div>
  )
}

Burger.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
}

export default Burger
